<template>
  <div id="vessel-container-master">
    <div class="vx-card p-6 list-container">
      <div class="table-container">
        <!-- no content -->
        <div v-if="enterpriseVessels.length == 0" class="not-found-message-area">
          <span class="not-found-message aisea-text-14-400-gray">リーファーコンテナが見つかりませんでした</span>
        </div>

        <div class="table-area-wrapper">
          <div class="table-area w-full">
            <div class="header row aisea-text-14-700-dark-gray">
              <div
                class="cell"
                v-for="(column, index) in columnDefs"
                :key="index"
                :class="{[`cell-${column.key}`]: true,  'ml-auto': index === columnDefs.length - 1}"
                :style="'width:' + column.width + 'px'">
                {{column.label}}
              </div>
            </div>
            <div class="data row aisea-text-14-400-black w-full"
              v-for="enterpriseVessel in enterpriseVessels" :key="enterpriseVessel.id">
              <vessel-container-list-item
                :enterpriseVessel="enterpriseVessel"
                :columnDefs="columnDefs"
                />
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import VesselContainerListItem from "./VesselContainerListItem.vue";
import { DeviceInfoMixin, ColorMixin } from "@/mixins";
import { createNamespacedHelpers } from "vuex";

const { mapActions, mapGetters } = createNamespacedHelpers("enterpriseVessel");
const { mapActions: mapActionsOfEcoShip } = createNamespacedHelpers("ecoShip");

export default {
  components: {
    VesselContainerListItem,
  },
  mixins: [DeviceInfoMixin, ColorMixin],
  props: {},
  data() {
    return {
      enterpriseVessels: [],
    };
  },
  async created() {
    this.getEnterpriseVessels();
    this.onResize();
  },
  watch: {
    onChangeWindowSize() {
      this.onResize();
    },
  },
  computed: {
    forceButtonUp() {
      const deviceType = this.getDeviceInfo().deviceType;
      const deviceOrientation = this.getDeviceInfo().deviceOrientation;
      const positionButtonNormal = ( deviceType === 'iPhone' || ( deviceType === 'iPad' && deviceOrientation === 'portrait' ));
      return !positionButtonNormal;
    },
    columnDefs () {
      return [
        {
          headerName: "船名",
          label: "船名",
          field: "name",
          width: 180,
          key: "vesselName",
        },
        {
          headerName: "コンテナ状況",
          label: "コンテナ状況",
          field: "vessel_category.id",
          width: 580,
        },
        {
          headerName: "更新日時",
          label: "更新日時",
          field: "lastUpdatedAt",
          width: 180
        },
      ];
    },
  },
  methods: {
    ...mapActions(["fetchVessels"]),
    ...mapGetters(["getVessels"]),
    ...mapActionsOfEcoShip([
      "setEnterpriseVesselsWithContainers",
      "fetchVesselContainers",
      "pushEnterpriseVesselAndContainers",
    ]),
    /**
     *  iPhone,iPadでのレフトメニュー表示制御.
     */
    onResize() {
      this.$nextTick(() => {
        if ( ["iPhone", "iPad"].includes( this.getDeviceInfo().deviceType )) {
          // iPhone, iPad はメニューを表示しない。
          this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", false);
          this.$store.dispatch("updateVerticalNavMenuWidth", "no-nav-menu");
        } else {
          this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
          const verticalNavMenuWidth = this.$store.state.reduceButton
            ? "reduced"
            : "default";
          this.$store.dispatch("updateVerticalNavMenuWidth", verticalNavMenuWidth);
        }
      });
    },

    async getEnterpriseVessels() {
      let payload = {
        name: null,
        is_disabled: false,
        is_deleted: false,
        page: 0,
        limit: 9999,
      };
      await this.fetchVessels(payload);
      this.getVessels().forEach((vessel) => {
        payload = {
          id: vessel.enterprise_vessel_id,
        };
        this.fetchVesselContainers(payload).then((res) => {
          var containers = res.enterprise_vessel_containers;
          if (containers.length > 0) {
            this.setEnterpriseVesselsWithContainers(vessel);
            this.enterpriseVessels.push(vessel);
          }
        });
      });
    },
    // TODO: 次のフェーズで使用する可能性があるためコメントを残しておく
    // goToContainerCustomerMaster() {
    //   this.$router.push({
    //     name: "addon-eco-ship-container-customer-master",
    //   });
    // },
  },
};
</script>


<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
#vessel-container-master {
  .not-found-message-area {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    position: absolute;
  }
  .table-area {
    min-width: fit-content;
  }
  .table-container {
    position: relative;
  }
  .table-area-wrapper {
    overflow-x: scroll;
    position: relative;
    height: 560px;
  }
  .header {
    font-weight: bold;
  }
  .row {
    min-height: 49px;
    height: fit-content;
    display: flex;
    border-bottom: solid 1px $aisea-light-white;
  }
  .clickable-cell-container {
    display: flex;
    transition: 0.3s;
    cursor: pointer;
    &:hover {
      background: $aisea-white;
    }
  }
  .cell {
    display: flex;
    margin-right: 20px;
    padding: 5px 10px;
    align-items: center;
    &.cell-vesselName {
      overflow-wrap: anywhere;
    }
    &.cell-select {
      width: 30px;
      .check-disabled {
        input {
          cursor: default;
        }

      }
    }
  }
}
</style>




